import styled, { css } from 'styled-components'

import { type MessageSender } from '../Message'

export const MessageContentStyled = styled.div<{ $sender: MessageSender }>`
  color: ${(props) => props.theme.colors.text.primary};
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: ${(props) => props.theme.fontWeights.normal};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
  overflow-wrap: break-word;

  ${(props) =>
    props.$sender === 'user'
      ? css`
          max-width: ${props.theme.typography.pxToRem(480)};
          padding: ${props.theme.typography.pxToRem(12)}
            ${props.theme.space.medium};
          background: ${props.theme.colors.comments.self.background};
          border-radius: ${props.theme.typography.pxToRem(16)};
        `
      : css`
          padding: 0;
          background: transparent;
        `}
`
